export default {"src":"/_next/static/media/relay-hero-image.6e8ed033.svg","height":434,"width":651,"blurWidth":0,"blurHeight":0};